import { ActionTracker } from "@dpdgroupuk/react-event-tracker";

export default new ActionTracker({
  projectRef: "NOT",
  debug: false,
  productId: 23,
  url: `${process.env.REACT_APP_ANALYTICS_APIS_URL}`,
});
